import { render, staticRenderFns } from "./BDXStatusPendingManagerListItem.vue?vue&type=template&id=35b8f11b&scoped=true"
import script from "./BDXStatusPendingManagerListItem.vue?vue&type=script&lang=js"
export * from "./BDXStatusPendingManagerListItem.vue?vue&type=script&lang=js"
import style0 from "./BDXStatusPendingManagerListItem.vue?vue&type=style&index=0&id=35b8f11b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b8f11b",
  null
  
)

export default component.exports